import { html } from 'lit';

export const DefaultIcon = html`
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3334_77372)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.71294 6.47927C2.9781 6.34125 3.27709 6.21883 3.59925 6.11144C4.18904 5.91485 4.88593 5.759 5.65385 5.65385C5.759 4.88593 5.91485 4.18904 6.11144 3.59925C6.21883 3.27709 6.34125 2.9781 6.47927 2.71294C4.66435 3.23402 3.23402 4.66435 2.71294 6.47927ZM8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5ZM8 2.5C7.94272 2.5 7.80858 2.53437 7.61422 2.781C7.42429 3.02199 7.23139 3.4017 7.06013 3.91547C6.90527 4.38004 6.77549 4.9317 6.67997 5.5472C7.10671 5.5162 7.5484 5.5 8 5.5C8.4516 5.5 8.89329 5.5162 9.32003 5.5472C9.22451 4.9317 9.09473 4.38004 8.93987 3.91547C8.76861 3.4017 8.57571 3.02199 8.38579 2.781C8.19142 2.53437 8.05728 2.5 8 2.5ZM10.3461 5.65385C10.241 4.88593 10.0852 4.18904 9.88856 3.59925C9.78117 3.27709 9.65875 2.9781 9.52073 2.71294C11.3357 3.23402 12.766 4.66435 13.2871 6.47927C13.0219 6.34125 12.7229 6.21883 12.4008 6.11144C11.811 5.91485 11.1141 5.759 10.3461 5.65385ZM9.44027 6.55973C8.98158 6.52087 8.49906 6.5 8 6.5C7.50094 6.5 7.01842 6.52087 6.55973 6.55973C6.52087 7.01842 6.5 7.50094 6.5 8C6.5 8.49906 6.52087 8.98158 6.55973 9.44027C7.01842 9.47913 7.50094 9.5 8 9.5C8.49906 9.5 8.98158 9.47913 9.44027 9.44027C9.47913 8.98158 9.5 8.49906 9.5 8C9.5 7.50094 9.47913 7.01842 9.44027 6.55973ZM10.4528 9.32002C10.4838 8.89329 10.5 8.4516 10.5 8C10.5 7.5484 10.4838 7.10671 10.4528 6.67998C11.0683 6.7755 11.62 6.90527 12.0845 7.06013C12.5983 7.23139 12.978 7.42429 13.219 7.61422C13.4656 7.80858 13.5 7.94272 13.5 8C13.5 8.05728 13.4656 8.19142 13.219 8.38579C12.978 8.57571 12.5983 8.76861 12.0845 8.93987C11.62 9.09473 11.0683 9.2245 10.4528 9.32002ZM9.32003 10.4528C8.89329 10.4838 8.4516 10.5 8 10.5C7.5484 10.5 7.10671 10.4838 6.67998 10.4528C6.7755 11.0683 6.90527 11.62 7.06013 12.0845C7.23139 12.5983 7.42429 12.978 7.61422 13.219C7.80858 13.4656 7.94272 13.5 8 13.5C8.05728 13.5 8.19142 13.4656 8.38579 13.219C8.57571 12.978 8.76861 12.5983 8.93987 12.0845C9.09473 11.62 9.22451 11.0683 9.32003 10.4528ZM9.52073 13.2871C9.65875 13.0219 9.78117 12.7229 9.88856 12.4008C10.0852 11.811 10.241 11.1141 10.3461 10.3461C11.1141 10.241 11.811 10.0852 12.4008 9.88856C12.7229 9.78117 13.0219 9.65875 13.2871 9.52073C12.766 11.3357 11.3357 12.766 9.52073 13.2871ZM6.47927 13.2871C4.66435 12.766 3.23402 11.3357 2.71294 9.52073C2.9781 9.65875 3.27709 9.78117 3.59925 9.88856C4.18904 10.0852 4.88593 10.241 5.65385 10.3461C5.759 11.1141 5.91485 11.811 6.11144 12.4008C6.21883 12.7229 6.34125 13.0219 6.47927 13.2871ZM5.5472 9.32003C4.9317 9.22451 4.38004 9.09473 3.91547 8.93987C3.4017 8.76861 3.02199 8.57571 2.781 8.38579C2.53437 8.19142 2.5 8.05728 2.5 8C2.5 7.94272 2.53437 7.80858 2.781 7.61422C3.02199 7.42429 3.4017 7.23139 3.91547 7.06013C4.38004 6.90527 4.9317 6.7755 5.5472 6.67998C5.5162 7.10671 5.5 7.5484 5.5 8C5.5 8.4516 5.5162 8.89329 5.5472 9.32003Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3334_77372">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

export const EdgelessIcon = html`
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.81819 4.75C5.78639 4.75 4.94995 5.58644 4.94995 6.61823C4.94995 7.65003 5.78639 8.48647 6.81819 8.48647C7.84998 8.48647 8.68642 7.65003 8.68642 6.61823C8.68642 5.58644 7.84998 4.75 6.81819 4.75ZM3.44995 6.61823C3.44995 4.75801 4.95796 3.25 6.81819 3.25C8.60235 3.25 10.0625 4.63721 10.1789 6.39189C11.0214 6.39271 11.8303 6.40588 12.672 6.60918C13.6053 6.83462 14.5372 7.28077 15.6466 8.11279L15.6669 8.12808L15.6863 8.14472C17.2527 9.49512 18.0368 11.678 18.0411 13.7229H19.7C20.1142 13.7229 20.45 14.0587 20.45 14.4729V19.1857C20.45 19.5999 20.1142 19.9357 19.7 19.9357H14.9872C14.573 19.9357 14.2372 19.5999 14.2372 19.1857V14.4729C14.2372 14.0587 14.573 13.7229 14.9872 13.7229H16.5411C16.5368 12.0177 15.8774 10.3023 14.7256 9.29708C13.7507 8.56904 13.0074 8.23335 12.3198 8.06725C11.6081 7.89535 10.9129 7.89185 9.96008 7.89185V7.83462C9.56016 8.8669 8.66616 9.65297 7.56824 9.90265V13.8067C9.06743 14.1477 10.1864 15.4887 10.1864 17.0911C10.1864 18.9514 8.67841 20.4594 6.81819 20.4594C4.95796 20.4594 3.44995 18.9514 3.44995 17.0911C3.44995 15.4887 4.56899 14.1476 6.06824 13.8067V9.90268C4.56899 9.56178 3.44995 8.22069 3.44995 6.61823ZM6.81819 15.2229C5.78639 15.2229 4.94995 16.0593 4.94995 17.0911C4.94995 18.1229 5.78639 18.9594 6.81819 18.9594C7.84998 18.9594 8.68642 18.1229 8.68642 17.0911C8.68642 16.0593 7.84998 15.2229 6.81819 15.2229ZM15.7372 18.4357V15.2229H18.95V18.4357H15.7372Z"
      fill="currentColor"
    />
  </svg>
`;

export const PageIcon = html`<svg
  width="16"
  height="16"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7 3.25C5.48122 3.25 4.25 4.48122 4.25 6V18C4.25 19.5188 5.48122 20.75 7 20.75H17C18.5188 20.75 19.75 19.5188 19.75 18V6C19.75 4.48122 18.5188 3.25 17 3.25H7ZM5.75 6C5.75 5.30964 6.30964 4.75 7 4.75H17C17.6904 4.75 18.25 5.30964 18.25 6V18C18.25 18.6904 17.6904 19.25 17 19.25H7C6.30964 19.25 5.75 18.6904 5.75 18V6ZM9 7.25C8.58579 7.25 8.25 7.58579 8.25 8C8.25 8.41421 8.58579 8.75 9 8.75H12.5C12.9142 8.75 13.25 8.41421 13.25 8C13.25 7.58579 12.9142 7.25 12.5 7.25H9ZM8.25 11.5C8.25 11.0858 8.58579 10.75 9 10.75H15C15.4142 10.75 15.75 11.0858 15.75 11.5C15.75 11.9142 15.4142 12.25 15 12.25H9C8.58579 12.25 8.25 11.9142 8.25 11.5ZM9 14.25C8.58579 14.25 8.25 14.5858 8.25 15C8.25 15.4142 8.58579 15.75 9 15.75H14C14.4142 15.75 14.75 15.4142 14.75 15C14.75 14.5858 14.4142 14.25 14 14.25H9Z"
    fill="currentColor"
  />
</svg> `;

export const RefreshIcon = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.25 12C3.25 7.16751 7.16751 3.25 12 3.25C14.2406 3.25 16.286 4.09311 17.8335 5.4782L17.8359 5.48034L19.25 6.75695V4C19.25 3.58579 19.5858 3.25 20 3.25C20.4142 3.25 20.75 3.58579 20.75 4V8.44444C20.75 8.85866 20.4142 9.19444 20 9.19444H15.5556C15.1413 9.19444 14.8056 8.85866 14.8056 8.44444C14.8056 8.03023 15.1413 7.69444 15.5556 7.69444H18.05L16.8331 6.5959C16.8327 6.59554 16.8323 6.59518 16.8319 6.59483C15.5489 5.44701 13.8568 4.75 12 4.75C7.99594 4.75 4.75 7.99594 4.75 12C4.75 16.0041 7.99594 19.25 12 19.25C15.4494 19.25 18.3378 16.8403 19.0704 13.6118C19.162 13.2079 19.5638 12.9547 19.9677 13.0464C20.3717 13.138 20.6248 13.5398 20.5332 13.9437C19.6489 17.8405 16.1651 20.75 12 20.75C7.16751 20.75 3.25 16.8325 3.25 12Z"
      fill="currentColor"
    />
  </svg>
`;

export const DeleteIcon = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M11 2.25C9.48122 2.25 8.25 3.48122 8.25 5V6.1499H4C3.53056 6.1499 3.15 6.53046 3.15 6.9999C3.15 7.46934 3.53056 7.8499 4 7.8499H4.3088L5.11923 19.1959C5.22202 20.635 6.41948 21.75 7.86224 21.75H16.1378C17.5805 21.75 18.778 20.635 18.8808 19.1959L19.6912 7.8499H20C20.4694 7.8499 20.85 7.46934 20.85 6.9999C20.85 6.53046 20.4694 6.1499 20 6.1499H15.75V5C15.75 3.48122 14.5188 2.25 13 2.25H11ZM14.25 6.1499V5C14.25 4.30964 13.6904 3.75 13 3.75H11C10.3096 3.75 9.75 4.30964 9.75 5V6.1499H14.25ZM18.1874 7.8499H5.81262L6.61542 19.0891C6.66214 19.7432 7.20644 20.25 7.86224 20.25H16.1378C16.7936 20.25 17.3379 19.7432 17.3846 19.0891L18.1874 7.8499ZM10.75 11C10.75 10.5858 10.4142 10.25 10 10.25C9.58579 10.25 9.25 10.5858 9.25 11V17C9.25 17.4142 9.58579 17.75 10 17.75C10.4142 17.75 10.75 17.4142 10.75 17V11ZM14 10.25C14.4142 10.25 14.75 10.5858 14.75 11V17C14.75 17.4142 14.4142 17.75 14 17.75C13.5858 17.75 13.25 17.4142 13.25 17V11C13.25 10.5858 13.5858 10.25 14 10.25Z"
    fill="currentColor"
  />
</svg> `;

export const EditIcon = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M18.3032 4.49775C18.6342 4.16742 19.1714 4.16742 19.5024 4.49775C19.8326 4.82726 19.8326 5.3609 19.5024 5.69041L19.0739 6.1181L17.8768 4.92334L18.3032 4.49775ZM16.8151 5.98296L18.0122 7.17771L10.9259 14.25H9.75006V13.0341L16.8151 5.98296ZM20.562 3.43604C19.6455 2.52132 18.1601 2.52132 17.2436 3.43604L8.47025 12.1921C8.32928 12.3328 8.25006 12.5238 8.25006 12.723V15C8.25006 15.4142 8.58585 15.75 9.00006 15.75H11.2362C11.4348 15.75 11.6254 15.6712 11.766 15.5309L20.562 6.75212C21.4794 5.83658 21.4794 4.35158 20.562 3.43604ZM4.75 6C4.75 5.30964 5.30964 4.75 6 4.75H12C12.4142 4.75 12.75 4.41421 12.75 4C12.75 3.58579 12.4142 3.25 12 3.25H6C4.48122 3.25 3.25 4.48122 3.25 6V18C3.25 19.5188 4.48122 20.75 6 20.75H18C19.5188 20.75 20.75 19.5188 20.75 18V12C20.75 11.5858 20.4142 11.25 20 11.25C19.5858 11.25 19.25 11.5858 19.25 12V18C19.25 18.6904 18.6904 19.25 18 19.25H6C5.30964 19.25 4.75 18.6904 4.75 18V6Z"
    fill="currentColor"
  />
</svg> `;

export const LinkIcon = html`
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3409_77679)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.7019 5.83896C14.2094 4.33145 16.6535 4.33145 18.161 5.83896C19.6685 7.34646 19.6685 9.79061 18.161 11.2981L16.4453 13.0138C16.2012 13.2579 15.8055 13.2579 15.5614 13.0138C15.3173 12.7698 15.3173 12.374 15.5614 12.13L17.2771 10.4142C18.2965 9.39488 18.2965 7.74219 17.2771 6.72284C16.2578 5.70349 14.6051 5.70349 13.5857 6.72284L11.2981 9.01048C10.2788 10.0298 10.2788 11.6825 11.2981 12.7019C11.4581 12.8619 11.633 12.9963 11.818 13.1055C12.1152 13.281 12.2138 13.6643 12.0383 13.9615C11.8628 14.2587 11.4795 14.3573 11.1823 14.1818C10.9076 14.0196 10.6492 13.8207 10.4142 13.5858C8.90671 12.0782 8.90671 9.6341 10.4142 8.1266L12.7019 5.83896ZM11.9617 10.0385C12.1372 9.74129 12.5204 9.64265 12.8177 9.81819C13.0924 9.98043 13.3508 10.1793 13.5857 10.4142C15.0932 11.9217 15.0932 14.3659 13.5857 15.8734L11.2981 18.161C9.7906 19.6685 7.34645 19.6685 5.83894 18.161C4.33144 16.6535 4.33144 14.2094 5.83894 12.7019L7.55467 10.9861C7.79875 10.7421 8.19448 10.7421 8.43855 10.9861C8.68263 11.2302 8.68263 11.6259 8.43855 11.87L6.72283 13.5858C5.70348 14.6051 5.70348 16.2578 6.72283 17.2771C7.74218 18.2965 9.39487 18.2965 10.4142 17.2771L12.7019 14.9895C13.7212 13.9702 13.7212 12.3175 12.7019 11.2981C12.5418 11.1381 12.367 11.0037 12.182 10.8945C11.8848 10.719 11.7861 10.3357 11.9617 10.0385Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3409_77679">
        <rect width="20" height="20" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
`;

export const CopyIcon = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M3.25 6C3.25 4.48122 4.48122 3.25 6 3.25H14C15.5188 3.25 16.75 4.48122 16.75 6V7.25H18C19.5188 7.25 20.75 8.48122 20.75 10V18C20.75 19.5188 19.5188 20.75 18 20.75H10C8.48122 20.75 7.25 19.5188 7.25 18V16.75H6C4.48122 16.75 3.25 15.5188 3.25 14V6ZM8.75 18C8.75 18.6904 9.30964 19.25 10 19.25H18C18.6904 19.25 19.25 18.6904 19.25 18V10C19.25 9.30964 18.6904 8.75 18 8.75H10C9.30964 8.75 8.75 9.30964 8.75 10V18ZM15.25 7.25H10C8.48122 7.25 7.25 8.48122 7.25 10V15.25H6C5.30964 15.25 4.75 14.6904 4.75 14V6C4.75 5.30964 5.30964 4.75 6 4.75H14C14.6904 4.75 15.25 5.30964 15.25 6V7.25Z"
    fill="currentColor"
  />
</svg> `;

export const CaptionIcon = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M4.25 7C4.25 5.48122 5.48122 4.25 7 4.25H12C13.5188 4.25 14.75 5.48122 14.75 7V10C14.75 11.5188 13.5188 12.75 12 12.75H7C5.48122 12.75 4.25 11.5188 4.25 10V7ZM7 5.75C6.30964 5.75 5.75 6.30964 5.75 7V10C5.75 10.6904 6.30964 11.25 7 11.25H12C12.6904 11.25 13.25 10.6904 13.25 10V7C13.25 6.30964 12.6904 5.75 12 5.75H7ZM4.25 15.5C4.25 15.0858 4.58579 14.75 5 14.75H19C19.4142 14.75 19.75 15.0858 19.75 15.5C19.75 15.9142 19.4142 16.25 19 16.25H5C4.58579 16.25 4.25 15.9142 4.25 15.5ZM5 18.25C4.58579 18.25 4.25 18.5858 4.25 19C4.25 19.4142 4.58579 19.75 5 19.75H14C14.4142 19.75 14.75 19.4142 14.75 19C14.75 18.5858 14.4142 18.25 14 18.25H5Z"
    fill="currentColor"
  />
</svg> `;

export const DuplicateIcon = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6 3.25C4.48122 3.25 3.25 4.48122 3.25 6V14C3.25 15.5188 4.48122 16.75 6 16.75H7.25V18C7.25 19.5188 8.48122 20.75 10 20.75H18C19.5188 20.75 20.75 19.5188 20.75 18V10C20.75 8.48122 19.5188 7.25 18 7.25H16.75V6C16.75 4.48122 15.5188 3.25 14 3.25H6ZM10 7.25H15.25V6C15.25 5.30964 14.6904 4.75 14 4.75H6C5.30964 4.75 4.75 5.30964 4.75 6V14C4.75 14.6904 5.30964 15.25 6 15.25H8C8.41421 15.25 8.75 15.5858 8.75 16V18C8.75 18.6904 9.30964 19.25 10 19.25H18C18.6904 19.25 19.25 18.6904 19.25 18V10C19.25 9.30964 18.6904 8.75 18 8.75H16H10C9.46561 8.75 9.00774 9.08568 8.82933 9.56024C8.68357 9.94796 8.2511 10.1441 7.86338 9.99835C7.47566 9.85259 7.27951 9.42012 7.42527 9.0324C7.81633 7.99216 8.82056 7.25 10 7.25ZM12.8871 10.489C12.6049 10.1858 12.1303 10.1688 11.8271 10.451C11.524 10.7333 11.507 11.2078 11.7892 11.511L12.4771 12.25H7.79999C7.38577 12.25 7.04999 12.5858 7.04999 13C7.04999 13.4142 7.38577 13.75 7.79999 13.75H12.4771L11.7892 14.489C11.507 14.7922 11.524 15.2667 11.8271 15.549C12.1303 15.8312 12.6049 15.8142 12.8871 15.511L14.7489 13.511C15.017 13.2231 15.017 12.7769 14.7489 12.489L12.8871 10.489Z"
    fill="currentColor"
  />
</svg> `;

export const CloseIcon = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5.46967 5.46967C5.76256 5.17678 6.23744 5.17678 6.53033 5.46967L12 10.9393L17.4697 5.46967C17.7626 5.17678 18.2374 5.17678 18.5303 5.46967C18.8232 5.76256 18.8232 6.23744 18.5303 6.53033L13.0607 12L18.5303 17.4697C18.8232 17.7626 18.8232 18.2374 18.5303 18.5303C18.2374 18.8232 17.7626 18.8232 17.4697 18.5303L12 13.0607L6.53033 18.5303C6.23744 18.8232 5.76256 18.8232 5.46967 18.5303C5.17678 18.2374 5.17678 17.7626 5.46967 17.4697L10.9393 12L5.46967 6.53033C5.17678 6.23744 5.17678 5.76256 5.46967 5.46967Z"
    fill="currentColor"
  />
</svg> `;

export const MoreIcon = html`
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3407_76065)">
      <path
        d="M12 6.99999C11.5398 6.99999 11.1667 6.6269 11.1667 6.16666C11.1667 5.70642 11.5398 5.33333 12 5.33333C12.4602 5.33333 12.8333 5.70642 12.8333 6.16666C12.8333 6.6269 12.4602 6.99999 12 6.99999Z"
        fill="currentColor"
      />
      <path
        d="M12 12.8333C11.5398 12.8333 11.1667 12.4602 11.1667 12C11.1667 11.5398 11.5398 11.1667 12 11.1667C12.4602 11.1667 12.8333 11.5398 12.8333 12C12.8333 12.4602 12.4602 12.8333 12 12.8333Z"
        fill="currentColor"
      />
      <path
        d="M12 18.6667C11.5398 18.6667 11.1667 18.2936 11.1667 17.8333C11.1667 17.3731 11.5398 17 12 17C12.4602 17 12.8333 17.3731 12.8333 17.8333C12.8333 18.2936 12.4602 18.6667 12 18.6667Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 5.75001C11.7699 5.75001 11.5833 5.93655 11.5833 6.16667C11.5833 6.39679 11.7699 6.58334 12 6.58334C12.2301 6.58334 12.4167 6.39679 12.4167 6.16667C12.4167 5.93655 12.2301 5.75001 12 5.75001ZM10.75 6.16667C10.75 5.47632 11.3096 4.91667 12 4.91667C12.6904 4.91667 13.25 5.47632 13.25 6.16667C13.25 6.85703 12.6904 7.41667 12 7.41667C11.3096 7.41667 10.75 6.85703 10.75 6.16667ZM12 11.5833C11.7699 11.5833 11.5833 11.7699 11.5833 12C11.5833 12.2301 11.7699 12.4167 12 12.4167C12.2301 12.4167 12.4167 12.2301 12.4167 12C12.4167 11.7699 12.2301 11.5833 12 11.5833ZM10.75 12C10.75 11.3096 11.3096 10.75 12 10.75C12.6904 10.75 13.25 11.3096 13.25 12C13.25 12.6904 12.6904 13.25 12 13.25C11.3096 13.25 10.75 12.6904 10.75 12ZM12 17.4167C11.7699 17.4167 11.5833 17.6032 11.5833 17.8333C11.5833 18.0635 11.7699 18.25 12 18.25C12.2301 18.25 12.4167 18.0635 12.4167 17.8333C12.4167 17.6032 12.2301 17.4167 12 17.4167ZM10.75 17.8333C10.75 17.143 11.3096 16.5833 12 16.5833C12.6904 16.5833 13.25 17.143 13.25 17.8333C13.25 18.5237 12.6904 19.0833 12 19.0833C11.3096 19.0833 10.75 18.5237 10.75 17.8333Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3407_76065">
        <rect width="20" height="20" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
`;

export const LoadingBanner = html`
  <svg
    width="140"
    height="96"
    viewBox="0 0 140 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4257_88403)">
      <g opacity="0.4">
        <g clip-path="url(#clip1_4257_88403)">
          <g clip-path="url(#clip2_4257_88403)">
            <g opacity="0.8" filter="url(#filter0_f_4257_88403)">
              <ellipse
                cx="45.5713"
                cy="61.2938"
                rx="45.5713"
                ry="61.2938"
                transform="matrix(-0.275152 -0.961401 0.994111 -0.108365 23.6692 80.3025)"
                fill="#C0BFC1"
              />
            </g>
            <g opacity="0.8" filter="url(#filter1_f_4257_88403)">
              <ellipse
                cx="49.6555"
                cy="50.1114"
                rx="49.6555"
                ry="50.1114"
                transform="matrix(-0.517539 -0.855659 0.945307 -0.326182 10.3975 87.9766)"
                fill="#C0BFC1"
              />
            </g>
            <g opacity="0.8" filter="url(#filter2_f_4257_88403)">
              <path
                d="M141.154 3.03247C167.539 22.8936 134.54 99.5878 124.212 92.7915C117.912 88.6456 113.733 60.4772 94.173 45.9086C81.6691 36.5955 56.6586 38.5939 41.1056 37.1878C1.22291 33.5821 114.548 -16.9943 141.154 3.03247Z"
                fill="#C0BFC1"
              />
            </g>
            <path
              d="M78.5971 45.1263C77.9794 49.5216 81.121 53.5957 85.6131 54.2271C90.1053 54.8584 94.2481 51.808 94.8658 47.4128C95.4835 43.0175 92.342 38.9434 87.8498 38.312C83.3577 37.6807 79.2149 40.7311 78.5971 45.1263Z"
              fill="url(#paint0_linear_4257_88403)"
            />
            <path
              d="M120.378 78.3637L119.989 81.1303C119.731 82.9654 119.562 84.15 119.36 85.0413C119.166 85.8959 118.999 86.1992 118.895 86.3451C118.499 86.9002 117.932 87.3171 117.277 87.5363C117.105 87.5938 116.76 87.6677 115.867 87.6141C114.934 87.5582 113.723 87.3905 111.847 87.1268L80.6109 82.7369C78.735 82.4733 77.524 82.3006 76.6125 82.0973C75.7385 81.9024 75.4276 81.7365 75.278 81.6337C74.7087 81.2424 74.2794 80.6856 74.0516 80.0428C73.9917 79.8739 73.9142 79.5361 73.9635 78.6612C74.0149 77.7488 74.1789 76.5635 74.4369 74.7283L75.6584 66.0369C75.8058 65.9369 75.9505 65.8411 76.0924 65.7498C77.1899 65.0437 78.3629 64.4423 79.7464 64.1873C81.8083 63.8072 83.9443 64.0829 85.8427 64.9742C87.1166 65.5723 88.0991 66.452 88.9822 67.4137C89.5619 68.0451 90.1807 68.8058 90.8604 69.6691L94.5285 66.9912C95.9295 65.9684 97.1371 65.0867 98.1922 64.4415C99.3051 63.761 100.491 63.1868 101.879 62.9626C103.947 62.6286 106.075 62.9506 107.951 63.8817C109.21 64.5065 110.172 65.4058 111.033 66.385C111.033 66.385 117.277 74.3919 120.378 78.3637Z"
              fill="url(#paint1_linear_4257_88403)"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M18.0193 52.2289C18.1346 51.4086 18.8931 50.837 19.7134 50.9523L67.2463 57.6326C68.0667 57.7479 68.6382 58.5064 68.5229 59.3268C68.4076 60.1471 67.6491 60.7187 66.8288 60.6034L19.2959 53.9231C18.4755 53.8078 17.904 53.0493 18.0193 52.2289Z"
              fill="white"
              fill-opacity="0.8"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M21.5681 26.9771C21.7218 25.8833 22.7332 25.1212 23.827 25.2749L47.5934 28.6151C48.6872 28.7688 49.4493 29.7801 49.2956 30.874C49.1419 31.9678 48.1305 32.7299 47.0367 32.5762L23.2703 29.236C22.1765 29.0823 21.4144 28.0709 21.5681 26.9771Z"
              fill="white"
              fill-opacity="0.8"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M19.55 41.336C19.6653 40.5156 20.4238 39.9441 21.2442 40.0593L68.7771 46.7397C69.5974 46.8549 70.169 47.6135 70.0537 48.4338C69.9384 49.2542 69.1799 49.8258 68.3595 49.7105L20.8267 43.0301C20.0063 42.9149 19.4347 42.1564 19.55 41.336Z"
              fill="white"
              fill-opacity="0.8"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.4883 63.1219C16.6036 62.3015 17.3621 61.7299 18.1824 61.8452L65.7153 68.5255C66.5357 68.6408 67.1072 69.3993 66.9919 70.2197C66.8766 71.0401 66.1181 71.6116 65.2978 71.4963L17.7649 64.816C16.9445 64.7007 16.373 63.9422 16.4883 63.1219Z"
              fill="white"
              fill-opacity="0.8"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.2358 72.0343C15.3511 71.2139 16.1096 70.6424 16.93 70.7576L64.4628 77.438C65.2832 77.5533 65.8548 78.3118 65.7395 79.1321C65.6242 79.9525 64.8657 80.5241 64.0453 80.4088L16.5125 73.7285C15.6921 73.6132 15.1205 72.8547 15.2358 72.0343Z"
              fill="white"
              fill-opacity="0.4"
            />
          </g>
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="filter0_f_4257_88403"
        x="-14.1589"
        y="-38.4709"
        width="172.444"
        height="136.638"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="12"
          result="effect1_foregroundBlur_4257_88403"
        />
      </filter>
      <filter
        id="filter1_f_4257_88403"
        x="-45.8333"
        y="-40.3932"
        width="155.805"
        height="139.072"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="12"
          result="effect1_foregroundBlur_4257_88403"
        />
      </filter>
      <filter
        id="filter2_f_4257_88403"
        x="8.68726"
        y="-25.6425"
        width="166.468"
        height="142.859"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="12"
          result="effect1_foregroundBlur_4257_88403"
        />
      </filter>
      <linearGradient
        id="paint0_linear_4257_88403"
        x1="102.492"
        y1="40.3698"
        x2="96.2289"
        y2="84.9319"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.578125" stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_4257_88403"
        x1="102.492"
        y1="40.3698"
        x2="96.2289"
        y2="84.9319"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.578125" stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
      <clipPath id="clip0_4257_88403">
        <rect width="140" height="96" fill="white" />
      </clipPath>
      <clipPath id="clip1_4257_88403">
        <rect
          x="11.7563"
          y="3.38196"
          width="130"
          height="88"
          rx="4"
          transform="rotate(8 11.7563 3.38196)"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip2_4257_88403">
        <rect
          width="130"
          height="88"
          fill="white"
          transform="translate(11.7563 3.38196) rotate(8)"
        />
      </clipPath>
    </defs>
  </svg>
`;

export const DarkLoadingBanner = html`
  <svg
    width="140"
    height="96"
    viewBox="0 0 140 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4391_90250)">
      <g opacity="0.4">
        <g clip-path="url(#clip1_4391_90250)">
          <g clip-path="url(#clip2_4391_90250)">
            <g opacity="0.8" filter="url(#filter0_f_4391_90250)">
              <ellipse
                cx="45.5713"
                cy="61.2938"
                rx="45.5713"
                ry="61.2938"
                transform="matrix(-0.275152 -0.961401 0.994111 -0.108365 23.6692 80.3025)"
                fill="#3E3E3F"
              />
            </g>
            <g opacity="0.8" filter="url(#filter1_f_4391_90250)">
              <ellipse
                cx="49.6555"
                cy="50.1114"
                rx="49.6555"
                ry="50.1114"
                transform="matrix(-0.517539 -0.855659 0.945307 -0.326182 10.3975 87.9766)"
                fill="#3E3E3F"
              />
            </g>
            <g opacity="0.8" filter="url(#filter2_f_4391_90250)">
              <path
                d="M141.154 3.03247C167.539 22.8936 134.54 99.5878 124.212 92.7915C117.912 88.6456 113.733 60.4772 94.173 45.9086C81.6691 36.5955 56.6586 38.5939 41.1056 37.1878C1.22291 33.5821 114.548 -16.9943 141.154 3.03247Z"
                fill="#3E3E3F"
              />
            </g>
            <path
              d="M78.5971 45.1263C77.9794 49.5216 81.121 53.5957 85.6131 54.2271C90.1053 54.8584 94.2481 51.808 94.8658 47.4128C95.4835 43.0175 92.342 38.9434 87.8498 38.312C83.3577 37.6807 79.2149 40.7311 78.5971 45.1263Z"
              fill="url(#paint0_linear_4391_90250)"
            />
            <path
              d="M120.378 78.3637L119.989 81.1303C119.731 82.9654 119.562 84.15 119.36 85.0413C119.166 85.8959 118.999 86.1992 118.895 86.3451C118.499 86.9002 117.932 87.3171 117.277 87.5363C117.105 87.5938 116.76 87.6677 115.867 87.6141C114.934 87.5582 113.723 87.3905 111.847 87.1268L80.6109 82.7369C78.735 82.4733 77.524 82.3006 76.6125 82.0973C75.7385 81.9024 75.4276 81.7365 75.278 81.6337C74.7087 81.2424 74.2794 80.6856 74.0516 80.0428C73.9917 79.8739 73.9142 79.5361 73.9635 78.6612C74.0149 77.7488 74.1789 76.5635 74.4369 74.7283L75.6584 66.0369C75.8058 65.9369 75.9505 65.8411 76.0924 65.7498C77.1899 65.0437 78.3629 64.4423 79.7464 64.1873C81.8083 63.8072 83.9443 64.0829 85.8427 64.9742C87.1166 65.5723 88.0991 66.452 88.9822 67.4137C89.5619 68.0451 90.1807 68.8058 90.8604 69.6691L94.5285 66.9912C95.9295 65.9684 97.1371 65.0867 98.1922 64.4415C99.3051 63.761 100.491 63.1868 101.879 62.9626C103.947 62.6286 106.075 62.9506 107.951 63.8817C109.21 64.5065 110.172 65.4058 111.033 66.385C111.033 66.385 117.277 74.3919 120.378 78.3637Z"
              fill="url(#paint1_linear_4391_90250)"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M18.0193 52.2289C18.1346 51.4086 18.8931 50.837 19.7134 50.9523L67.2463 57.6326C68.0667 57.7479 68.6382 58.5064 68.5229 59.3268C68.4076 60.1471 67.6491 60.7187 66.8288 60.6034L19.2959 53.9231C18.4755 53.8078 17.904 53.0493 18.0193 52.2289Z"
              fill="white"
              fill-opacity="0.8"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M21.5681 26.9771C21.7218 25.8833 22.7332 25.1212 23.827 25.2749L47.5934 28.6151C48.6872 28.7688 49.4493 29.7801 49.2956 30.874C49.1419 31.9678 48.1305 32.7299 47.0367 32.5762L23.2703 29.236C22.1765 29.0823 21.4144 28.0709 21.5681 26.9771Z"
              fill="white"
              fill-opacity="0.8"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M19.55 41.336C19.6653 40.5156 20.4238 39.9441 21.2442 40.0593L68.7771 46.7397C69.5974 46.8549 70.169 47.6135 70.0537 48.4338C69.9384 49.2542 69.1799 49.8258 68.3595 49.7105L20.8267 43.0301C20.0063 42.9149 19.4347 42.1564 19.55 41.336Z"
              fill="white"
              fill-opacity="0.8"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.4883 63.1219C16.6036 62.3015 17.3621 61.7299 18.1824 61.8452L65.7153 68.5255C66.5357 68.6408 67.1072 69.3993 66.9919 70.2197C66.8766 71.0401 66.1181 71.6116 65.2978 71.4963L17.7649 64.816C16.9445 64.7007 16.373 63.9422 16.4883 63.1219Z"
              fill="white"
              fill-opacity="0.8"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.2358 72.0344C15.3511 71.214 16.1096 70.6424 16.93 70.7577L64.4628 77.438C65.2832 77.5533 65.8548 78.3118 65.7395 79.1322C65.6242 79.9525 64.8657 80.5241 64.0453 80.4088L16.5125 73.7285C15.6921 73.6132 15.1205 72.8547 15.2358 72.0344Z"
              fill="white"
              fill-opacity="0.4"
            />
          </g>
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="filter0_f_4391_90250"
        x="-14.1589"
        y="-38.4709"
        width="172.444"
        height="136.638"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="12"
          result="effect1_foregroundBlur_4391_90250"
        />
      </filter>
      <filter
        id="filter1_f_4391_90250"
        x="-45.8333"
        y="-40.3932"
        width="155.805"
        height="139.072"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="12"
          result="effect1_foregroundBlur_4391_90250"
        />
      </filter>
      <filter
        id="filter2_f_4391_90250"
        x="8.68726"
        y="-25.6425"
        width="166.468"
        height="142.859"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="12"
          result="effect1_foregroundBlur_4391_90250"
        />
      </filter>
      <linearGradient
        id="paint0_linear_4391_90250"
        x1="102.492"
        y1="40.3698"
        x2="96.2289"
        y2="84.9319"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.578125" stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_4391_90250"
        x1="102.492"
        y1="40.3698"
        x2="96.2289"
        y2="84.9319"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.578125" stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
      <clipPath id="clip0_4391_90250">
        <rect width="140" height="96" fill="white" />
      </clipPath>
      <clipPath id="clip1_4391_90250">
        <rect
          x="11.7563"
          y="3.38196"
          width="130"
          height="88"
          rx="4"
          transform="rotate(8 11.7563 3.38196)"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip2_4391_90250">
        <rect
          width="130"
          height="88"
          fill="white"
          transform="translate(11.7563 3.38196) rotate(8)"
        />
      </clipPath>
    </defs>
  </svg>
`;
